module.exports = __webpack_public_path__ + "img/173-mali.eb4e63d0.svg";